"use client";

import Image, { type ImageProps } from "next/image";
import { useState } from "react";

type BlogImageProps = ImageProps & {
  wrapperClassName?: string;
  objectFit?: string;
  objectPosition?: string;
};

const BlogImage = ({
  wrapperClassName,
  className,
  objectFit,
  objectPosition,
  ...props
}: BlogImageProps) => {
  const [status, setStatus] = useState<"loading" | "loaded" | "error">(
    "loading",
  );

  const w = props.width ? Number(props.width) : 0;
  const h = props.height ? Number(props.height) : 0;

  const imgStyle = { ...props.style, objectFit, objectPosition };

  return (
    <span className={`gs--blog-image ${wrapperClassName ?? ""}`}>
      {status === "error" ? (
        <span
          className="gs--blog-image__fallback"
          style={{
            width: w || undefined,
            aspectRatio: w && h ? w / h : undefined,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            className="gs--blog-image__fallback-icon"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </svg>
        </span>
      ) : (
        <>
          {status === "loading" && (
            <span className="gs--blog-image__skeleton" />
          )}
          <Image
            quality={90}
            {...props}
            className={`gs--blog-image__img ${className ?? ""} ${status === "loading" ? "gs--blog-image__img--loading" : ""}`}
            style={imgStyle}
            onLoad={() => setStatus("loaded")}
            onError={() => setStatus("error")}
          />
          <noscript>
            <img
              src={
                typeof props.src === "string"
                  ? props.src
                  : (props.src as { src: string }).src
              }
              alt={props.alt || ""}
              width={w || undefined}
              height={h || undefined}
              className={`gs--blog-image__img ${className ?? ""}`}
              style={imgStyle as React.CSSProperties}
              loading="lazy"
            />
          </noscript>
        </>
      )}
    </span>
  );
};

export default BlogImage;
